import globals from "@/utils/globals"
import { cookie } from "@/utils/cookie"

let coupon = {
  code: null,
  discount: null
}

if (globals.signupDiscount) {
  coupon = globals.signupDiscount.coupon
}

const saveSignupDiscountCookie = () => {
  if (coupon.code) {
    saveCookie(coupon.code)
  }
}

const saveCookie = (code) => {
  const validity = 1 / 24 // 1 hour
  cookie("coupon_code", code, validity)
}

const deleteTrialessCouponCookie = () => {
  if (cookie("coupon_trialess")) {
    const validity = -1
    cookie("coupon_code", "", validity)
    cookie("coupon_trialess", "", validity)
  }
}

export { coupon, saveSignupDiscountCookie, deleteTrialessCouponCookie }
